import { defaultClient } from '@mint-sdk/api-core';
import z from 'zod';

import {
  CreateReportPullLogRequestSchema,
  ReportPullLogItemSchema,
  ReportPullLogResponseSchema,
  ReportQueryParams,
  ReportStatusEnum,
  ReportTypeEnum,
} from '../shared/schemas/ReportSchema.js';

export const launchReport = defaultClient.mutation({
  url: 'omni-connector/report-pull-log/' as const,
  method: 'POST',
  requestSchema: CreateReportPullLogRequestSchema,
  responseSchema: ReportPullLogResponseSchema,
});

export const getReportPullLogs = defaultClient.query({
  url: 'omni-connector/report-pull-log/' as const,
  method: 'GET',
  responseSchema: ReportPullLogResponseSchema,
  querySchema: ReportQueryParams,
  snakeCaseQueryParams: true,
});

export type LaunchReportBodyType = z.infer<
  typeof CreateReportPullLogRequestSchema
>;

export type ReportPullLogItemSchemaType = z.infer<
  typeof ReportPullLogItemSchema
>;
export type ReportStatusEnumType = z.infer<typeof ReportStatusEnum>;
export type ReportTypeEnum = z.infer<typeof ReportTypeEnum>;
